import { render } from "./App.vue?vue&type=template&id=2a9eed14"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a9eed14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a9eed14', __exports__)) {
    console.log('reload')
    api.reload('2a9eed14', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=2a9eed14", () => {
    console.log('re-render')
    api.rerender('2a9eed14', render)
  })

}


export default __exports__